import React, { Fragment } from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Field, FieldArray } from 'redux-form';
import cns from 'classnames';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../../shared/components/VerbButton';
import { CUSTOM_HOME_ROW_TYPES_OBJECT } from '../../../../../../shared/Constants';
import BasicText from '../../../../../../shared/components/formComponents/groups/BasicText';
import BasicToggle from '../../../../../../shared/components/formComponents/groups/BasicToggle';
import DisplayOnlyInput from '../../../../../../shared/components/formComponents/inputs/DisplayOnlyInput';
import CustomHomeOption from './CustomHomeOption';

const CustomRow = ({
    index = 0,
    category = '',
    fields = [],
    isVerbAdmin = false,
    setEditing = () => {},
    isEditing = false,
    rowType = 'COLLECTION',
    shouldHide = false,
    addCollectionMessage = 'Collection(s) in this section',
    collectionOptions = [],
    indexOfDescriptionBeingEdited = 0,
    isGlobalContentRow = false,
    isFeaturedCollectionRow = false
}) => (
    <Table striped={false} bordered={false} hover={isVerbAdmin}>
        <thead>
            <tr>
                {!isGlobalContentRow && (
                    <th style={{ width: '16.66667%' }}>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            fontAwesomeIcon={'fa-angle-up'}
                            onClick={() => {
                                setEditing({ isEditing: false });
                                fields.swap(index, index - 1);
                            }}
                            title={'Move Up'}
                            disabled={!index}
                        />
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                            fontAwesomeIcon={'fa-angle-down'}
                            onClick={() => {
                                setEditing({ isEditing: false });
                                fields.swap(index, index + 1);
                            }}
                            title={'Move Down'}
                            disabled={index === fields.length - 1}
                        />
                        {
                            rowType === 'COLLECTION' ? (
                                <VerbButton
                                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                    fontAwesomeIcon={'fa-trash'}
                                    onClick={() => {
                                        setEditing({ isEditing: false });
                                        fields.remove(index);
                                    }}
                                />
                            ) : null
                        }
                    </th>
                )}
                <th className={'description-container'} style={{ width: '75%' }}>
                    {isEditing && indexOfDescriptionBeingEdited === index ? (
                        <Fragment>
                            <Field
                                name={category ? `${category}.label` : 'label'}
                                className={'company-form-field no-horizontal-margin col-6'}
                                inputClassName={'no-padding'}
                                styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                                component={BasicText}
                            />
                            {rowType !== 'GLOBAL_CONTENT_ROW' && (
                                <span style={{ ...(isGlobalContentRow ? { marginLeft: 10 } : {}) }}>
                                    <VerbButton
                                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                        fontAwesomeIcon={'fa-check'}
                                        className={'save-section-btn'}
                                        onClick={() =>
                                            setEditing({ isEditing: false, indexOfDescriptionBeingEdited: 0 })
                                        }
                                    />
                                </span>
                            )}
                        </Fragment>
                    ) : (
                        <Fragment>
                            <span>
                                {isGlobalContentRow
                                    ? 'Title: '
                                    : `[Type: ${CUSTOM_HOME_ROW_TYPES_OBJECT[rowType]?.label}]`}
                            </span>
                            &nbsp;&nbsp;
                            <Field
                                name={category ? `${category}.label` : 'label'}
                                className={'custom-home-section-edit'}
                                component={DisplayOnlyInput}
                            />
                            {rowType !== 'GLOBAL_CONTENT_ROW' && (
                                <span style={{ ...(isGlobalContentRow ? { marginLeft: 10 } : {}) }}>
                                    <VerbButton
                                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                                        className={cns({ hidden: shouldHide })}
                                        fontAwesomeIcon={'fa-pencil'}
                                        onClick={() =>
                                            setEditing({ isEditing: true, indexOfDescriptionBeingEdited: index })
                                        }
                                    />
                                </span>
                            )}
                        </Fragment>
                    )}
                </th>
            </tr>
        </thead>
        <tbody>
            <tr hidden={isFeaturedCollectionRow || shouldHide}>
                <td>
                    <label className={'form-description light table-sub-title'}>Optional row description</label>
                </td>
                <td>
                    <div>
                        <Field
                            name={category ? `${category}.subtext` : 'subtext'}
                            placeholder={'Optional: Displays under row title'}
                            className={'company-form-field no-horizontal-margin col-10'}
                            disabled={rowType === 'GLOBAL_CONTENT_ROW'}
                            component={BasicText}
                            inputClassName={'no-padding'}
                            styleProps={{ horizontal: true, inputStyle: { bordered: true, 'full-width': true } }}
                        />
                    </div>
                </td>
            </tr>
            {['COLLECTION', 'FEATURED_COLLECTION', 'GLOBAL_CONTENT_ROW'].includes(rowType) ? (
                <Fragment>
                    {rowType === 'COLLECTION' && (
                        <tr key={`${rowType}_${index}_lock`}>
                            <td>
                                <label className={'form-description light table-sub-title'}>
                                        Lock order of Paths in row
                                </label>
                            </td>
                            <td>
                                <div>
                                    <Field
                                        name={category ? `${category}.isOrderLocked` : 'isOrderLocked'}
                                        className={'company-form-field no-horizontal-margin col-10'}
                                        component={BasicToggle}
                                        inputClassName={'no-padding'}
                                        styleProps={{
                                            horizontal: true,
                                            inputStyle: { bordered: true, 'full-width': true }
                                        }}
                                        id={'custom-row-is-order-locked-toggle'}
                                    />
                                </div>
                            </td>
                        </tr>
                    )}
                    <tr key={`${rowType}_${index}_add_collection`}>
                        <td>
                            <label className={'form-description light table-sub-title'}>{addCollectionMessage}</label>
                        </td>
                        <td>
                            <div>
                                <FieldArray
                                    name={category ? `${category}.content` : 'content'}
                                    label={'Collections'}
                                    allowMultipleCollections={
                                        rowType === 'COLLECTION' || rowType === 'GLOBAL_CONTENT_ROW'
                                    }
                                    collectionOptions={collectionOptions}
                                    canEdit={rowType !== 'GLOBAL_CONTENT_ROW'}
                                    isGlobalContentRow={isGlobalContentRow}
                                    component={CustomHomeOption}
                                />
                            </div>
                        </td>
                    </tr>
                </Fragment>
            ) : (
                <tr key={`${rowType}_${index}_message`}>
                    <td />
                    <td>
                        <p>{CUSTOM_HOME_ROW_TYPES_OBJECT[rowType].message}</p>
                    </td>
                </tr>
            )}
        </tbody>
    </Table>
);

CustomRow.propTypes = {
    index: PropTypes.number,
    category: PropTypes.string,
    fields: PropTypes.array,
    isVerbAdmin: PropTypes.bool,
    setEditing: PropTypes.func,
    isEditing: PropTypes.bool,
    rowType: PropTypes.string,
    shouldHide: PropTypes.bool,
    addCollectionMessage: PropTypes.string,
    collectionOptions: PropTypes.array,
    indexOfDescriptionBeingEdited: PropTypes.number,
    isGlobalContentRow: PropTypes.bool,
    isFeaturedCollectionRow: PropTypes.bool
};

export default CustomRow;
